module.exports = __webpack_public_path__ + "static/media/IMG_3599.2b709dd1.jpg";